(function () {
    "use strict";

    angular.module("app").factory("externalInstallationRequestApi", ExternalInstallationRequestApi);

    ExternalInstallationRequestApi.$inject = ["apiClientFactory",];
    function ExternalInstallationRequestApi(apiClientFactory) {
        const routePrefix = "api/installations/external-requests";
        return {
            get: (id) => (successCallback, errorCallback, finallyCallback) => apiClientFactory.get(`${routePrefix}/${id}`)("", response => successCallback(response.data), errorCallback, finallyCallback),
            saveRemark: apiClientFactory.put("api/Installation/Request/SaveRemark/"),
            sendBackToSecurityOfficer: (requestId) => (successCallback, errorCallback, finallyCallback) => apiClientFactory.post(`${routePrefix}/reject`)({ requestId }, response => successCallback(response.data), errorCallback, finallyCallback),
            acceptRequest: apiClientFactory.post(`${routePrefix}/accept`),
        };
    }
})();
